import { collectParagraphElements, isParseError, parseXml, W_NS } from "./xmlUtils";
import { readTableMeta, type OoxmlTableMeta } from "./tableCore";

export type { OoxmlTableMeta };

export function parseDocumentTableMeta(xml: string): OoxmlTableMeta[] {
  const doc = parseXml(xml);
  if (isParseError(doc)) return [];

  const tables = doc.getElementsByTagNameNS(W_NS, "tbl");
  const result: OoxmlTableMeta[] = [];
  for (let i = 0; i < tables.length; i++) {
    result.push(readTableMeta(tables[i], i));
  }
  return result;
}

export async function extractTableMetaFromDocx(
  arrayBuffer: ArrayBuffer,
): Promise<OoxmlTableMeta[]> {
  const JSZip = (await import("jszip")).default;
  const zip = await JSZip.loadAsync(arrayBuffer);
  const xml = await zip.file("word/document.xml")?.async("text");
  if (!xml) return [];
  return parseDocumentTableMeta(xml);
}

/** Tables only — paragraph meta still covers w:p inside cells separately. */
export function collectTableParagraphCount(xml: string): number {
  const doc = parseXml(xml);
  if (isParseError(doc)) return 0;
  return collectParagraphElements(doc).length;
}
